import React, { useState, useCallback, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import { MdSearch } from 'react-icons/md';

import Clickwrap from 'components/Clickwrap';
import { useDetectClickOutside } from 'hooks/useDetectClickOutside';

/**
 * @description: SearchOption Component for Leads Table
 * @param {*}
 * @return {*}
 */
export const SearchOption = ({ options, setOptions, value, onChange, placeholderText }) => {
  const [showOption, setShowOption] = useState(false);
  const [searchValue, setSearchValue] = useState(value);
  const searchBoxRef = useDetectClickOutside({
    onTriggered: () => setShowOption(false),
  });

  const delayedQuery = useCallback(
    debounce((q) => onChange(q), 500),
    [],
  );

  const onSearchInputChange = (e) => {
    setSearchValue(e.target.value);
    delayedQuery(e.target.value);
  };

  const onViewOptionClick = () => {
    setShowOption(!showOption);
  };

  const onChangeCheck = (selected) => {
    const newOptions = options.slice();
    newOptions[selected].checked = !newOptions[selected].checked;
    setOptions([...newOptions]);
  };

  useEffect(() => {
    if (value === '') setSearchValue(value);
  }, [value]);

  return (
    <div
      className="view-options"
      ref={searchBoxRef}
      style={{ position: 'relative' }}
    >
      <MdSearch
        size={20}
        className="view-options__icon"
      />
      <input
        className="view-options__search"
        placeholder={placeholderText}
        value={searchValue}
        onChange={onSearchInputChange}
        onClick={onViewOptionClick}
      />
      <div
        className={clsx('view-options__container', {
          active: showOption,
        })}
      >
        {options && (
          <section className="view-options__content options-menu p-3">
            <p className="view-options__title ml-0">Refine By</p>
            {options?.map((option, idx) => {
              return (
                <div
                  key={`lead-view-option__${option.id}`}
                  className="d-flex view-option view-option--search"
                >
                  <Clickwrap
                    name={option.id}
                    checked={option.checked}
                    onChange={() => onChangeCheck(idx)}
                    className="small"
                  />
                  <label
                    htmlFor={option.id}
                    className="ml-2 mb-0"
                  >
                    {option.label}
                  </label>
                </div>
              );
            })}
          </section>
        )}
      </div>
    </div>
  );
};

SearchOption.propTypes = {
  options: PropTypes.array,
  setOptions: PropTypes.func,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholderText: PropTypes.string,
};
